export { ProfileButton as default } from '@skin-seoul/shared-components';